export const ENV = {
    ENV:'prod',
    PORTAL_PROXY: '/portal',
    FIREBASE_CONFIG:  {
        "apiKey": "AIzaSyAC7q-eeVbl9jXLXA0OzM07n83GRwuvC9M",
        "authDomain": "nova-214bc.firebaseapp.com",
        "databaseURL": "https://nova-214bc.firebaseio.com",
        "projectId": "nova-214bc",
        "storageBucket": "nova-214bc.appspot.com",
        "messagingSenderId": "424881452220"
    },
    PROXIES_URL: {
        "/portal-dev": "http://www.nova.local/app_dev.php",
        "/portal-stage": "https://www.novaterim.net/app_dev.php",
        "/portal": "https://www.novaterim.com"
    }
};



// WEBPACK FOOTER //
// ./src/config/environment.ts